const NewsBgColorsData = [
    {
        id: 1,
        newstheme: "#2FCC6E",
    },
    {
        id: 2,
        newstheme: "#FC7336",
    },
    {
        id: 3,
        newstheme: "#23B5D3",
    },
    {
        id: 4,
        newstheme: "#D9A239",
    },
    {
        id: 5,
        newstheme: "#ED1C24",
    },
    {
        id: 6,
        newstheme: "#E4D85D",
    },
    {
        id: 7,
        newstheme: "#51344D",
    },
    {
        id: 8,
        newstheme: "#8C36FC",
    },
    {
        id: 9,
        newstheme: "#D3234D",
    },
    {
        id: 10,
        newstheme: "#DDB967",
    },
];
export default NewsBgColorsData
